import React from "react";
import AppRoutes from "./routers/index";
import "./styles/index.css";
import { ToastContainer } from "react-toastify";

const AppRoute = () => {
  return (
    <>
      <AppRoutes /> 
      <ToastContainer />
    </>
  );
};

export default AppRoute;
